import { render, staticRenderFns } from "./CollegeBasicDetailEdit.vue?vue&type=template&id=f7cc1876&scoped=true&"
import script from "./CollegeBasicDetailEdit.vue?vue&type=script&lang=js&"
export * from "./CollegeBasicDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./CollegeBasicDetailEdit.vue?vue&type=style&index=0&id=f7cc1876&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cc1876",
  null
  
)

export default component.exports